import { render, staticRenderFns } from "./CampaignsGeneral.vue?vue&type=template&id=683abb9a&"
import script from "./CampaignsGeneral.vue?vue&type=script&lang=js&"
export * from "./CampaignsGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports